export const addClassAction = (onlineClass) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(application);
      firestore
        .collection('classes')
        .add(onlineClass)
        .then(() => {
          dispatch({
            type: "ADD_CLASS",
            success: true
          });
        })
        .catch((err) => {
          dispatch({
            type: "ADD_CLASS_ERR",
            err
          });
        });
    };
  };
  